/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from '@express-labs/raven-ui';
import { cn } from '@express-labs/raven-tools';

import s from './ProductImage.module.scss';

function ProductImage({
  imageSrc, description, className, imageAlt, imageHref,
}) {
  if (imageSrc) {
    return (
      <figure className={cn(s.imageContainer, className)} aria-label="image container">
        <a href={imageHref}>
          <img
            alt={imageAlt}
            src={imageSrc}
            width={260}
            height={378}
            loading="lazy"
          />
        </a>
        <figcaption className={s.imageTitle}>
          <Link
            as="a"
            theme="dark"
            size="body"
            href={imageHref}
          >
            {description}
          </Link>
        </figcaption>
      </figure>
    );
  }
  return null;
}

ProductImage.propTypes = {
  imageSrc: PropTypes.string,
  imageAlt: PropTypes.string,
  imageHref: PropTypes.string,
  description: PropTypes.string,
  className: PropTypes.string,
};

export default ProductImage;
